import { render, staticRenderFns } from "./DialogChangeArticleStatus.vue?vue&type=template&id=5ed9011e&scoped=true"
import script from "./DialogChangeArticleStatus.vue?vue&type=script&lang=js"
export * from "./DialogChangeArticleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9011e",
  null
  
)

export default component.exports